import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=5bd755f4&scoped=true&"
import script from "./Maintenance.vue?vue&type=script&lang=js&"
export * from "./Maintenance.vue?vue&type=script&lang=js&"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=5bd755f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd755f4",
  null
  
)

export default component.exports